import { Component, OnInit, ViewChild } from '@angular/core';

import { AppInformationService, ArkUnitOfWork, UtilityService } from 'app/core/core.module';
import { DevExtremeModule, DxDataGridComponent } from 'devextreme-angular';

@Component({
    selector: 'app-announcements',
    templateUrl: './announcements.component.html',
    styleUrls: ['./announcements.component.scss'],
    imports: [DevExtremeModule],
    standalone: true
})
export class AnnouncementsComponent implements OnInit {
    announcements: any[];
    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

    constructor(private appInfo: AppInformationService, private utility: UtilityService, private uow: ArkUnitOfWork) {}

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        this.announcements  = await this.uow.getAnnouncements();
    }
    getAnnouncementSheet(item: any) {
        const result = this.utility.getAnnouncementSheet(item.fileName);
    }
}
